import './index.less';
import colTree from "./ColTree"
import taxon from "./Taxon"
import search from "./Search"
import dataset from "./Dataset"
import datasetSearch from "./DatasetSearch"
import bibTex from "./components/BibTex"
import { BreakDownWrapper } from './Taxon/BreakDownWrapper';
export const Tree = colTree;
export const Taxon = taxon;
export const Search = search;
export const Dataset = dataset;
export const DatasetSearch = datasetSearch;
export const BibTex = bibTex;
export const TaxonBreakdown = BreakDownWrapper;
